import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {DIALOG_CONFIG} from 'ac-infra';
import {CustomErrorStateMatcher} from '../../../../../utils/custom-error-state-matcher.directive';
import {confirmPasswordValidator} from '../../../../../utils/confirm-password-validator.directive';

@Component({
  selector: 'credentials-dialog',
  templateUrl: './credentials-dialog.component.html',
  styleUrls: ['./credentials-dialog.component.scss']
})
export class CredentialsDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('mapForm') form: NgForm;

  data;
  confirmationControl: FormGroup;
  matcher: any;
  isEdit: boolean;
  type: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) { }

  ngOnInit(): void {

    this.dialogConfig.submitButtonDisabled = true;
    this.data = this.dialogConfig.dialogData.selectedItem;
    this.isEdit = this.dialogConfig.dialogData.isEditMode;
    this.type = this.dialogConfig.dialogData.type;

    this.matcher = new CustomErrorStateMatcher();

    this.confirmationControl = new FormGroup({
      password: this.type === 'ROUTER' ?
        new FormControl('', [Validators.pattern('(?=.*[a-zA-Z].*)(?=.*\\d.*)\\S{8,20}')]) : new FormControl(),
      userName: new FormControl(),
      'confirm-password': new FormControl(),
      identifier: new FormControl()
    }, { validators: confirmPasswordValidator });
  }

  ngAfterViewInit(): void {
    this.form.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.confirmationControl.valid;
    });
  }

}
